import { Button, FormControl, Stack, Typography, SxProps, Theme } from '@mui/material';
import cx from 'classnames';
import React from 'react';

import i18n from 'FRONTEND/utils/i18n';

export interface ButtonItem <T> {
  value: T;
  label: string;
  icon?: React.ReactNode;
  backgroundImage?: string;
  sx?: SxProps<Theme>;
}

interface TilePickerProps<T> {
  buttonList?: ButtonItem<T>[];
  selectedValue?: T;
  onChange?: (value: T) => void;
  isVertical?: boolean;
  emptyMessage?: string;
  className?: string;
}

export const TilePicker = <T, >({
  buttonList = [],
  selectedValue = null,
  onChange = () => {},
  isVertical = false,
  emptyMessage = i18n._('No options available'),
  className = '',
  ...otherProps
}: TilePickerProps<T>) => {
  const buttonListClasses = cx(className);

  const handleChange = (value: T): void => {
    onChange(value);
  };

  return (
    <FormControl variant='standard' {...otherProps}>
      {buttonList.length > 0 ? (
        <Stack className={buttonListClasses} sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: isVertical ? 'column' : 'row' }}>
          {buttonList.map((item) => (
            <Button
              key={item.label}
              color={selectedValue === item.value ? 'primary' : 'inherit'}
              onClick={() => handleChange(item.value)}
              variant='outlined'
              startIcon={item.icon}
              sx={{
                backgroundSize: 'cover',
                minWidth: '230px',
                fontWeight: 400,
                fontSize: '14px',
                marginRight: 1,
                marginTop: 1,
                ...item.sx,
              }}
            >
              {item.label}
            </Button>
          ))}
        </Stack>
      ) : (
        <Typography variant='body2' color='textSecondary'>
          {emptyMessage}
        </Typography>
      )}
    </FormControl>
  );
};
